module.exports = __webpack_public_path__ + "static/media/wicketRoundPykesVenzel.f702aff8.jpg";